import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  zoneImg: {
    border: 'solid 2px #2C2D3E4D',
    marginBottom: '-5px',
    color: 'red',
  },
  zoneImgActive: {
    border: 'solid 2px #3C419A',
  },
}));
